import { render, staticRenderFns } from "./FoodSharePointsList.vue?vue&type=template&id=01620322&scoped=true"
import script from "./FoodSharePointsList.vue?vue&type=script&lang=js"
export * from "./FoodSharePointsList.vue?vue&type=script&lang=js"
import style0 from "./FoodSharePointsList.vue?vue&type=style&index=0&id=01620322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01620322",
  null
  
)

export default component.exports